import URLS from "@api/constants/urls";
import {
  handleGlobalDeleteRequest,
  handleGlobalPostRequest,
  handleGlobalPutRequest,
} from "@api/functions/changeRequests";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { URLSearchParamsInit } from "react-router-dom";
import {
  IFuelTypesResponseSchema,
  IFuelTypesSubmitSchema,
} from "./fuelTypesAPI.types";
import { IGlobalMetaSchema } from "@api/types/globalService.types";

const getAllFuelTypesAPI = ({
  searchParams,
  signal,
}: {
  searchParams?: URLSearchParamsInit;
  signal?: AbortSignal;
}): Promise<{ data: IFuelTypesResponseSchema[]; meta: IGlobalMetaSchema }> =>
  handleGlobalGetRequestQuery({ url: URLS.FUEL_TYPES, searchParams, signal });

const getSingleFuelTypesAPI = (
  id: string
): Promise<{ data: IFuelTypesResponseSchema }> =>
  handleGlobalGetRequestQuery({
    url: `${URLS.FUEL_TYPES}/${id}`,
  });

const createFuelTypesAPI = (
  data: IFuelTypesSubmitSchema
): Promise<{ data: IFuelTypesResponseSchema }> =>
  handleGlobalPostRequest({ url: URLS.FUEL_TYPES, data });

const updateFuelTypesAPI = (
  data: IFuelTypesSubmitSchema
): Promise<{ data: IFuelTypesResponseSchema }> =>
  handleGlobalPutRequest({ url: `${URLS.FUEL_TYPES}/${data.id}`, data });

const deleteFuelTypesAPI = (id: number) =>
  handleGlobalDeleteRequest({ url: `${URLS.FUEL_TYPES}/${id}` });

export {
  getAllFuelTypesAPI,
  getSingleFuelTypesAPI,
  createFuelTypesAPI,
  updateFuelTypesAPI,
  deleteFuelTypesAPI,
};
